import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_GROUP_ID,
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_ID,

    ACTION_GROUPCONFIDENTIALITYDEED_SAVE,

    ACTION_GROUPCONFIDENTIALITYDEED_CREATE,

    ACTION_GROUPCONFIDENTIALITYDEED_DELETE,

    ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE,

    IGroupConfidentialityDeedLoadByGroupIdAction,
    IGroupConfidentialityDeedLoadByIdAction,
    IGroupConfidentialityDeedLoadFailureAction,
    IGroupConfidentialityDeedLoadSuccessAction,

    IGroupConfidentialityDeedSaveAction,
    IGroupConfidentialityDeedSaveSuccessAction,
    IGroupConfidentialityDeedSaveFailureAction,

    IGroupConfidentialityDeedCreateAction,
    IGroupConfidentialityDeedCreateSuccessAction,
    IGroupConfidentialityDeedCreateFailureAction,

    IGroupConfidentialityDeedDeleteAction,
    IGroupConfidentialityDeedDeleteSuccessAction,
    IGroupConfidentialityDeedDeleteFailureAction,

    IGroupConfidentialityDeedValidateAction,
    IGroupConfidentialityDeedValidateSuccessAction,
    IGroupConfidentialityDeedValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/groupConfidentialityDeed";
import { groupConfidentialityDeedApi } from "../services/groupConfidentialityDeed";

export const
    getGroupConfidentialityDeedByGroupIdEpic = (action$): Observable<IGroupConfidentialityDeedLoadSuccessAction | IGroupConfidentialityDeedLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_GROUP_ID)
            .mergeMap((action: IGroupConfidentialityDeedLoadByGroupIdAction) => {
                return groupConfidentialityDeedApi
                    .getGroupConfidentialityDeedByGroupId(action.groupId)
                    .map(response =>
                        LoadSuccess(response.groupConfidentialityDeed, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getGroupConfidentialityDeedByIdEpic = (action$): Observable<IGroupConfidentialityDeedLoadSuccessAction | IGroupConfidentialityDeedLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_ID)
            .mergeMap((action: IGroupConfidentialityDeedLoadByIdAction) => {
                return groupConfidentialityDeedApi
                    .getGroupConfidentialityDeedById(action.id)
                    .map(response =>
                        LoadSuccess(response.groupConfidentialityDeed, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setGroupConfidentialityDeedEpic = (action$): Observable<IGroupConfidentialityDeedSaveSuccessAction | IGroupConfidentialityDeedSaveFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONFIDENTIALITYDEED_SAVE)
            .mergeMap((action: IGroupConfidentialityDeedSaveAction) => {
                return groupConfidentialityDeedApi
                    .setGroupConfidentialityDeed(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.groupConfidentialityDeed, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createGroupConfidentialityDeedEpic = (action$): Observable<IGroupConfidentialityDeedCreateSuccessAction | IGroupConfidentialityDeedCreateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONFIDENTIALITYDEED_CREATE)
            .mergeMap((action: IGroupConfidentialityDeedCreateAction) => {
                return groupConfidentialityDeedApi
                    .createGroupConfidentialityDeed(action.groupId)
                    .map(response =>
                        CreateSuccess(
                            response.groupConfidentialityDeed,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    deleteGroupConfidentialityDeedEpic = (action$): Observable<IGroupConfidentialityDeedDeleteSuccessAction | IGroupConfidentialityDeedDeleteFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONFIDENTIALITYDEED_DELETE)
            .mergeMap((action: IGroupConfidentialityDeedDeleteAction) => {
                return groupConfidentialityDeedApi
                    .deleteGroupConfidentialityDeed(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    },
    validateGroupConfidentialityDeedEpic = (action$): Observable<IGroupConfidentialityDeedValidateSuccessAction | IGroupConfidentialityDeedValidateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE)
            .mergeMap((action: IGroupConfidentialityDeedValidateAction) => {
                return groupConfidentialityDeedApi
                    .validateGroupConfidentialityDeed(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.groupConfidentialityDeed, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }